import React, { useState, lazy } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { MapPin, Phone, Mail, Clock, CheckCircle, MessageCircle } from 'lucide-react';
export function ContactPage() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <main className="pt-40 pb-20 bg-gray-50" data-id="element-407">
      <div className="bg-white py-16 mb-12 shadow-sm" data-id="element-408">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-409">
          <MessageCircle className="w-16 h-16 mx-auto mb-6 text-primary" data-id="element-410" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-411">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-412">
            Have questions? We're here to help! Reach out to us via phone,
            email, or visit us in person.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-413">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8" data-id="element-414">
          {/* Contact Info */}
          <div className="lg:col-span-1 flex flex-col space-y-6" data-id="element-415">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-416">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-417">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-418">
                <div className="flex items-start" data-id="element-419">
                  <MapPin className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-420" />
                  <div data-id="element-421">
                    <p className="font-semibold text-gray-900" data-id="element-422">Address</p>
                    <p className="text-gray-600" data-id="element-423">
                      1363 S. Old US 23
                      <br data-id="element-424" />
                      Brighton, Michigan 48114
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-425">
                  <Phone className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-426" />
                  <div data-id="element-427">
                    <p className="font-semibold text-gray-900" data-id="element-428">Phone</p>
                    <a href="tel:8107753153" className="text-gray-600 hover:text-primary transition-colors" data-id="element-429">
                      (810) 775-3153
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-430">
                  <Mail className="w-6 h-6 text-primary mr-4 mt-1" data-id="element-431" />
                  <div data-id="element-432">
                    <p className="font-semibold text-gray-900" data-id="element-433">Email</p>
                    <a href="mailto:info@limitlesstaekwondo.com" className="text-gray-600 hover:text-primary transition-colors" data-id="element-434">
                      info@limitlesstaekwondo.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex-1" data-id="element-435">
              <div className="flex items-center mb-6" data-id="element-436">
                <Clock className="w-6 h-6 text-primary mr-3" data-id="element-437" />
                <h3 className="text-xl font-bold text-gray-900" data-id="element-438">Class Hours</h3>
              </div>
              <ul className="space-y-3 text-gray-600" data-id="element-439">
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-440">
                  <span data-id="element-441">Mon - Thu</span>
                  <span className="font-medium" data-id="element-442">4:00 PM - 8:30 PM</span>
                </li>
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-443">
                  <span data-id="element-444">Friday</span>
                  <span className="font-medium" data-id="element-445">4:00 PM - 7:30 PM</span>
                </li>
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-446">
                  <span data-id="element-447">Saturday</span>
                  <span className="font-medium" data-id="element-448">9:00 AM - 12:00 PM</span>
                </li>
                <li className="flex justify-between" data-id="element-449">
                  <span data-id="element-450">Sunday</span>
                  <span className="font-medium" data-id="element-451">Closed</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2 flex flex-col" data-id="element-452">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex-1" data-id="element-453">
              {isSubmitted ? <div className="text-center py-12" data-id="element-454">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-455">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-456" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-457">
                    Message Sent!
                  </h3>
                  <p className="text-gray-600" data-id="element-458">
                    Thank you for contacting us. We will get back to you as soon
                    as possible.
                  </p>
                </div> : <>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-459">
                    Send us a Message
                  </h3>
                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-460">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-461">
                      <Input label="First Name" placeholder="John" required data-id="element-462" />
                      <Input label="Last Name" placeholder="Doe" required data-id="element-463" />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-464">
                      <Input label="Email" type="email" placeholder="john@example.com" required data-id="element-465" />
                      <Input label="Phone" type="tel" placeholder="(555) 555-5555" required data-id="element-466" />
                    </div>
                    <div data-id="element-467">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-468">
                        Message
                      </label>
                      <textarea className="w-full rounded-md border border-gray-300 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent h-32" placeholder="How can we help you?" required data-id="element-469"></textarea>
                    </div>
                    <Button type="submit" size="lg" data-id="element-470">
                      Send Message
                    </Button>
                  </form>
                </>}
            </div>
          </div>
        </div>

        {/* Google Maps Embed - Full Width */}
        <div className="rounded-xl h-96 w-full overflow-hidden shadow-sm border border-gray-100 max-w-[1300px] mx-auto" data-id="element-471">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47002.53163046062!2d-83.79395453403092!3d42.58377622093753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88235b2f75d20ff3%3A0xbec33fd70210b995!2sLimitless%20Martial%20Arts!5e0!3m2!1sen!2sus!4v1768600954796!5m2!1sen!2sus" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Limitless Martial Arts Location" data-id="element-472"></iframe>
        </div>
      </div>
    </main>;
}